import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "description"];
import { c as _c } from "react-compiler-runtime";
import EmbeddedCommentableArea from './EmbeddedCommentableArea';
import ChildrenErrorBoundary from '../../../components/errors/ChildrenErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ControlledCommentableArea(t0) {
  "use memo";

  const $ = _c(11);
  let children;
  let description;
  let propsForWrapper;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      children,
      description
    } = _t);
    propsForWrapper = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = children;
    $[2] = description;
    $[3] = propsForWrapper;
  } else {
    children = $[1];
    description = $[2];
    propsForWrapper = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== description || $[6] !== propsForWrapper) {
    t1 = /*#__PURE__*/_jsx(EmbeddedCommentableArea, Object.assign({
      metaDescription: description
    }, propsForWrapper, {
      children: children
    }));
    $[4] = children;
    $[5] = description;
    $[6] = propsForWrapper;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== t1) {
    t2 = /*#__PURE__*/_jsx(ChildrenErrorBoundary, {
      fingerprint: "controlled-commentable-area",
      originalChildren: children,
      children: t1
    });
    $[8] = children;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}